export default __webpack_public_path__ + "static/media/license-bg-mobile.474a4e04.webp";